<script lang="ts" setup>
import { computed } from 'vue';

import { useChatStore } from '#layers/ai/stores/chat';

defineOptions({ inheritAttrs: false });

const chatStore = useChatStore();

const isSubmitDisabled = computed(() => !chatStore.canSendMessage);

function handleStopClick() {
	chatStore.stop();
}
</script>

<template>
	<DButton
		v-if="chatStore.isBusy"
		type="button"
		size="sm"
		color="neutral"
		variant="soft"
		square
		icon="lucide:square"
		:aria-label="$t('ai.chat.stop')"
		:title="$t('ai.chat.stop')"
		v-bind="$attrs"
		@click="handleStopClick"
	/>

	<DButton
		v-else
		type="submit"
		size="sm"
		square
		icon="lucide:send-horizontal"
		:aria-label="$t('ai.chat.submit')"
		:title="$t('ai.chat.submit')"
		:disabled="isSubmitDisabled"
		v-bind="$attrs"
	/>
</template>
